import {isRTL} from '../../../Localization';

export const deleteDropTriggerSide = 34;

export function computeDeleteDropLeft(elementRect, dialogRect) {
    return isRTL() ? elementRect.left - dialogRect.left : elementRect.left - dialogRect.left;
}

export function computeDeleteDropTop(elementRect, dialogRect) {
    return elementRect.top - dialogRect.top;
}
